import { i18n } from '@/core/lang/core.i18n';

export const CALENDAR_API = {
  CALENDAR_INFO: 'calendar',
  CALENDAR_BY_USER: 'calendar/list',
  CALENDAR_ALL: 'calendar/all',
  CLASS_SCHEDULE: 'classes/calendar'
}

export const FREQUENCY = [
  {
    key: '',
    value: i18n.t('calendar.frequency.notSelected')
  },
  {
    key: 'DAILY',
    value: i18n.t('calendar.frequency.daily')
  },
  {
    key: 'WEEKLY',
    value: i18n.t('calendar.frequency.weekly')
  },
  {
    key: 'MONTHLY',
    value: i18n.t('calendar.frequency.monthly')
  },
  {
    key: 'YEARLY',
    value: i18n.t('calendar.frequency.yearly')
  }
]

export const EVENTS_STATUS_DEFAULT = 'CONFIRMED';

export const EVENTS_STATUS = [
  {
    key: 'TENTATIVE',
    value: i18n.t('calendar.status.tentative')
  },
  {
    key: 'CONFIRMED',
    value: i18n.t('calendar.status.confirmed')
  },
  {
    key: 'CANCELLED',
    value: i18n.t('calendar.status.cancelled')
  }
]

export const TASKS_STATUS = [
  {
    key: 'CANCELLED',
    value: i18n.t('calendar.status.cancelled')
  },
  {
    key: 'COMPLETED',
    value: i18n.t('calendar.status.completed')
  },
  {
    key: 'IN_PROCESS',
    value: i18n.t('calendar.status.inProcess')
  },
  {
    key: 'NEEDS_ACTION',
    value: i18n.t('calendar.status.needsAction')
  }
]

export const CALENDAR_TYPES = [
  { key: 'personalCalendars', value: i18n.t('calendar.data.personal')         },
  { key: 'studentCalendars', value: i18n.t('calendar.data.courses')           },
  { key: 'teacherCalendars', value: i18n.t('calendar.data.courses')           },
  { key: 'organizationCalendars', value: i18n.t('calendar.data.organization') }
]

export const END_REPEAT = [
  { key: 'NEVER', value: i18n.t('calendar.repeat.never') },
  { key: 'AFTER', value: i18n.t('calendar.repeat.after') },
  { key: 'ON_DATE', value: i18n.t('calendar.repeat.onDate') }
]

export const FEQ_LIST_WEEKDAY = [
  { key: 'SU', value: i18n.t('calendar.week.su') },
  { key: 'MO', value: i18n.t('calendar.week.mo') },
  { key: 'TU', value: i18n.t('calendar.week.tu') },
  { key: 'WE', value: i18n.t('calendar.week.we') },
  { key: 'TH', value: i18n.t('calendar.week.th') },
  { key: 'FR', value: i18n.t('calendar.week.fr') },
  { key: 'SA', value: i18n.t('calendar.week.sa') }
]

export const FEQ_LIST_MONTHYEAR = [
  { key: '1',  value: i18n.t('calendar.month.jan')  },
  { key: '2',  value: i18n.t('calendar.month.feb')  },
  { key: '3',  value: i18n.t('calendar.month.mar')  },
  { key: '4',  value: i18n.t('calendar.month.apr')  },
  { key: '5',  value: i18n.t('calendar.month.may')  },
  { key: '6',  value: i18n.t('calendar.month.jun')  },
  { key: '7',  value: i18n.t('calendar.month.jul')  },
  { key: '8',  value: i18n.t('calendar.month.aug')  },
  { key: '9',  value: i18n.t('calendar.month.sep')  },
  { key: '10', value: i18n.t('calendar.month.oct') },
  { key: '11', value: i18n.t('calendar.month.nov') },
  { key: '12', value: i18n.t('calendar.month.dec')}
]

export const FEQ_DAY_POSITION = [
  { key: '1', value: i18n.t('calendar.posday.1') },
  { key: '2', value: i18n.t('calendar.posday.2') },
  { key: '3', value: i18n.t('calendar.posday.3') },
  { key: '4', value: i18n.t('calendar.posday.4') },
  { key: '5', value: i18n.t('calendar.posday.5') },
  { key: '-1', value: i18n.t('calendar.posday.-1') }
]

export const FEQ_DAY_OF_MONTH = [
  { key: 'SU', value: i18n.t('calendar.week.su') },
  { key: 'MO', value: i18n.t('calendar.week.mo') },
  { key: 'TU', value: i18n.t('calendar.week.tu') },
  { key: 'WE', value: i18n.t('calendar.week.we') },
  { key: 'TH', value: i18n.t('calendar.week.th') },
  { key: 'FR', value: i18n.t('calendar.week.fr') },
  { key: 'SA', value: i18n.t('calendar.week.sa') },
  //{ key: 'BYMONTHDAY', value: i18n.t('calendar.week.dm')}
]
